import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context';
import AppRoutes from './routes';

/**
 * Main App Component
 * Sets up React Router with BrowserRouter and uses centralized routes.
 * Wraps the application with AuthContext for authentication state management.
 * 
 * Uses enterprise-standard practices:
 * - Lazy loading for route components
 * - Protected routes for authenticated pages
 * - Proper error handling
 * - Loading states
 * - Centralized route configuration
 * - AuthContext for authentication state management
 */
function App() {
  // Check if Coming Soon flag is set in environment variables
  const comingSoonFlag = process.env.REACT_APP_COMING_SOON_FLAG;

  // If Coming Soon flag is set to "yes", show Coming Soon page for all routes
  if (comingSoonFlag === 'yes') {
    return (
      <BrowserRouter>
        <AuthProvider>
          <div className="h-screen w-full bg-white">
            <React.Suspense fallback={
              <div className="flex items-center justify-center min-h-screen bg-[#A5F3FC]">
                <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            }>
              {React.createElement(
                React.lazy(() => import('./pages/ComingSoon').then(module => ({ default: module.default })))
              )}
            </React.Suspense>
          </div>
        </AuthProvider>
      </BrowserRouter>
    );
  }

  // Normal routing behavior when Coming Soon flag is not set or not "yes"
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="h-screen w-full bg-[#A5F3FC]">
          <AppRoutes />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
